"use client";

import { useState } from "react";
import Reveal from "./Reveal";
import { trackEvent } from "@/lib/analytics";
import { FAQ_ITEMS } from "./faq-data";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    const next = openIndex === index ? null : index;
    setOpenIndex(next);
    if (next !== null) {
      trackEvent("faq_opened", { question: FAQ_ITEMS[index].question });
    }
  };

  return (
    <section className="block" id="faq" style={{ paddingTop: 40 }}>
      <div className="wrap">
        <Reveal className="sec-head center">
          <span className="eyebrow">FAQ</span>
          <h2 className="serif">
            Questions, <em className="hl">answered</em>
          </h2>
        </Reveal>
        <Reveal className="faq">
          {FAQ_ITEMS.map(({ question, answer }, i) => (
            <div key={question} className={`qa${openIndex === i ? " open" : ""}`}>
              <button
                className="qbtn"
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
              >
                {question}
                <span className="sign" aria-hidden="true">+</span>
              </button>
              <div className="ans">
                <p>{answer}</p>
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
